require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-117-trello-sync-options.json") })
        }
      }, "path---article-117-trello-sync-options");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-117-trello-sync-options!./.cache/json/article-117-trello-sync-options.json
// module id = 474
// module chunks = 231608221292675